import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getAllProductapi, getPriceRangeFunction, getProductByIdFunction, getSuggestedProductFunction } from "../api/product";
import { getCategoryInPriceRangeFunction } from "../api/category";


export const useProductStore = create(
    persist(
        (set, get) => ({
            product: null,
            selectedProduct: null,
            loading: false,
            categoryInPriceRange: [],
            recentProduct: null,
            selectedproductToBuy: [],
            suggestedProduct: [],
            reload: true,
            setReload: (reload) => {
                set({ reload: reload })
            },
            setselectedProductToBuy: (product) => {
                set({ selectedproductToBuy: [product] })
            },
            getAllProduct: async (pageNumber, pageSize, search, field) => {
                set({ loading: true })
                try {
                    const res = await getAllProductapi(pageNumber, pageSize, search, field)
                    set({ loading: false, product: res?.products })
                    const data = res?.products?.slice(1, 8);
                    set({ recentProduct: data })
                    return res
                } catch (error) {
                    console.error("Login failed:", error);
                    set({ loading: false });
                    throw error;
                }
            },
            getProductById: async (id) => {
                try {
                    set({ loading: true })
                    const res = await getProductByIdFunction(id)
                    // console.log("selectedProduct", res)
                    set({ selectedProduct: res, loading: false })
                } catch (error) {
                    console.error("Login failed:", error);
                    set({ loading: false });
                    throw error;
                }
            },
            getPriceRange: async () => {
                try {
                    set({ loading: true })
                    const res = await getPriceRangeFunction()
                    set({ loading: false })
                    return res
                } catch (error) {
                    console.error("Login failed:", error);
                    set({ loading: false });
                    throw error;
                }
            },
            getCategoryInPriceRange: async (min, max, categoryId) => {
                try {
                    set({ loading: true })
                    const res = await getCategoryInPriceRangeFunction(min, max, categoryId)
                    set({ loading: false })
                    // console.log("min, max, categoryId", res)
                    if (categoryId) {
                        set({ product: res })
                    }
                    else {
                        set({ categoryInPriceRange: res })
                    }
                    return res
                } catch (error) {
                    console.error("Login failed:", error);
                    set({ loading: false });
                    throw error;
                }
            },
            getRecentProduct: async (pageNumber, pageSize, search, field) => {
                set({ loading: true })
                try {
                    const res = await getAllProductapi(pageNumber, pageSize, search, field)
                    set({ loading: false, product: res?.products })
                    const data = res?.products?.slice(1, 8);
                    set({ recentProduct: data })
                    return res
                } catch (error) {
                    console.error("Login failed:", error);
                    set({ loading: false });
                    throw error;
                }
            },
            getSuggestedProduct: async (id) => {
                try {
                    // set({ loading: true })
                    const res = await getSuggestedProductFunction(id)
                    // console.log("selectedProduct", res)
                    set({ suggestedProduct: res, loading: false })
                } catch (error) {
                    console.error("Login failed:", error);
                    set({ loading: false });
                    throw error;
                }
            },
        }),
        {
            name: "product-buy-storage",
            partialize: (state) => ({ selectedproductToBuy: state.selectedproductToBuy }),
        }
    )
)
